import endsWith from "lodash/endsWith";
import Avatar from "react-avatar";
import styled from "styled-components";
export default {
    Avatar: styled(Avatar) `
    overflow: hidden;

    .sb-avatar__text {
      line-height: 1;
      div span span {
        font-family: ${({ theme }) => theme["font-family-base"]};
        line-height: ${({ size }) => (endsWith(size, "%") ? 1 : `calc(${size} / 3)`)} !important;
        font-size: ${({ size }) => (endsWith(size, "%") ? size : `calc(${size} / 3)`)} !important;
      }
    }

    .sb-avatar__image {
      object-fit: cover;
    }
  `
};
